import { render, staticRenderFns } from "./notationList.vue?vue&type=template&id=b9b6e108&scoped=true"
import script from "./notationList.vue?vue&type=script&lang=js"
export * from "./notationList.vue?vue&type=script&lang=js"
import style0 from "./notationList.vue?vue&type=style&index=0&id=b9b6e108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b6e108",
  null
  
)

export default component.exports